import { Logger } from 'typescript-log'
import { httpGet } from '../../../helpers'
import { EPaperResponseDTO } from './helpers'

export async function getIssue(
    logger: Logger,
    validateGetEPaper: (value: any) => EPaperResponseDTO,
    numberOfIssues: number,
    cuePublication: string,
    caller: string,
): Promise<EPaperResponseDTO> {
    return httpGet({
        log: logger,
        validate: validateGetEPaper,
        baseUrl: `https://editions.thewest.com.au`,
        path: `ccidist-ws/wan/${cuePublication}/issues`,
        query: {
            draft: false,
            json: true,
            limit: numberOfIssues,
            skipSections: false,
            sortBy: `created`,
            sortOrder: `desc`,
            start: 1,
            submit: 'submit',
        },
        customHeaders: {
            caller,
        },
        fetchOptions: {
            cache: 'no-store',
        },
    })
}
